module.exports = __webpack_public_path__ + "img/2.0f80fb05.jpg";